import React, { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core';
import { Attempt } from '../../../../../../config/api/models/Answers';
import StudentAnswerChip from './StudentAnswerChip';
import {
  getMessageByQuestionType,
  QuestionType,
} from '../../../../../../config/api/models/QuestionType';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import {
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledSummary,
} from './Atoms';
import ScoreSummaryContent from './ScoreSummaryContent';
import { AttemptLabel } from '../solution/Atoms';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';

type Props = {
  questionType?: QuestionType;
  attempt: Attempt;
  label: string;
  index: number;
};

const StudentAnswerAttempt: FC<Props> = ({ questionType, attempt, label, index }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [expanded, setExpanded] = useState<boolean>(false);
  const handleChange = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  useEffect(() => {
    if (index === 0) setExpanded(true);
  }, [index, setExpanded]);

  return attempt && !attempt.answers ? (
    <StyledSummary>
      <AttemptLabel>{t(`trajectory.sections.shared.answers.${label}`)}</AttemptLabel>
      <ScoreSummaryContent
        score={attempt.score}
        maxScore={attempt.maxScore}
        scoredAtDate={attempt.scoredAt.date}
      />
    </StyledSummary>
  ) : (
    <StyledAccordion onChange={handleChange} defaultExpanded={index === 0}>
      <StyledAccordionSummary>
        <AttemptLabel>
          <FontAwesomeSpriteIcon
            icon={expanded ? SpriteIconsLight.ANGLE_UP : SpriteIconsLight.ANGLE_DOWN}
            color={theme.palette.text.primary}
            iconSize="md"
          />
          {t(`trajectory.sections.shared.answers.${label}`)}
        </AttemptLabel>
        {attempt && <ScoreSummaryContent
          score={attempt.score}
          maxScore={attempt.maxScore}
          scoredAtDate={attempt.scoredAt.date}
        />}
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        {attempt?.answers?.length > 0 ? (
          <>
            {attempt.answers.map((answer, index) => (
              <StudentAnswerChip
                key={index}
                answer={answer.answer}
                correct={answer.correct}
                grey={questionType === QuestionType.ESSAY}
              />
            ))}
          </>
        ) : (
          <>{getMessageByQuestionType(t, questionType)}</>
        )}
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};

export default StudentAnswerAttempt;
